// frontend/src/modules/invoicing/components/StatusBadge.tsx
import * as React from 'react';
import { statusPill, statusDot, type StatusTone } from '../../../design-system/visual';
import type { InvoiceStatus } from '../types';

const LABEL: Record<InvoiceStatus, string> = {
  draft:     'Draft',
  sent:      'Sent',
  paid:      'Paid',
  overdue:   'Overdue',
  cancelled: 'Cancelled',
  partial:   'Partially paid',
  accepted:  'Accepted',
  declined:  'Declined',
};

const TONE: Record<InvoiceStatus, StatusTone> = {
  draft:     'muted',
  sent:      'info',
  paid:      'success',
  overdue:   'warning',
  cancelled: 'destructive',
  partial:   'warning',
  accepted:  'success',
  declined:  'destructive',
};

export function StatusBadge({ status }: { status: InvoiceStatus }) {
  const tone = TONE[status];
  return (
    <span className={statusPill(tone)}>
      <span className={statusDot(tone)} />
      {LABEL[status]}
    </span>
  );
}
